import {
  Company
} from '../const';

export class Points {
  constructor() {
    this.points = document.querySelector('.points');
    if (this.points === null) {
      return;
    }
    this.list = document.querySelector('.points__list');
    this.addresses = null;
    this.searchContainer = this.points.querySelector('.control--search');
    this.search = this.points.querySelector('[name=points-search]');
    this.reset = this.points.querySelector('.control__reset');
    this.callback = {};

    this.searchInputHandler = this.searchInputHandler.bind(this);
    this.listClickHandler = this.listClickHandler.bind(this);
    this.resetClickHandler = this.resetClickHandler.bind(this);

    this.search.addEventListener('input', this.searchInputHandler);
    this.reset.addEventListener('click', this.resetClickHandler);
  }

  getPoints() {
    return this.points;
  }

  init(data) {
    return new Promise((resolve) => {
      this.createList(data);
      resolve(this);
    });

  }

  createList(data) {
    const that = this;
    let pointsList = data;
    let array = pointsList.features;
    let fragment = document.createDocumentFragment();
    array.forEach(function (item) {
      let pointItem = that.createPoint(item);
      fragment.appendChild(pointItem);
    });
    this.list.appendChild(fragment);
    this.addresses = this.list.querySelectorAll('.points__item');
  }

  createPoint(obj) {
    let address = obj.properties.balloonContentBody;
    let company = obj.properties.hintContent;
    let id = obj.id;
    const metro = obj.properties.balloonMetro;
    const busstop = obj.properties.balloonBus;
    const isCash = obj.properties.ballonCash;
    const isPostamat = obj.properties.ballonAuto;
    let point = this.createCustomPoint(address, company, id, metro, busstop, isCash, isPostamat);
    return point;
  }

  createCustomPoint(address, company, id, metro = '', busstop = '', isCash, isPostamat) {
    const template = document.querySelector('#points__data').content.querySelector('.points__item');
    const cloneTemplate = template.cloneNode(true);
    const metroContainer = cloneTemplate.querySelector('.points__metro');
    const busstopContainer = cloneTemplate.querySelector('.points__busstop');
    const cashContainer = cloneTemplate.querySelector('.points__cash');
    const postamatContainer = cloneTemplate.querySelector('.points__auto');

    const isMetro = Boolean(metro) && typeof metro === 'string';
    const isBusstop = Boolean(busstop) && typeof busstop === 'string';

    cloneTemplate.querySelector('.points__address').textContent = address;

    if (isMetro) {
      metroContainer.textContent = metro;
      busstopContainer.remove();
    } else {
      metroContainer.remove();
      if (isBusstop) {
        busstopContainer.textContent = busstop;
      } else {
        busstopContainer.remove();
      }
    }
    if (!isCash) {
      cashContainer.remove();
    }
    if (!isPostamat) {
      postamatContainer.remove();
    }

    switch (company) {
      case Company.CDEK:
        cloneTemplate.dataset.company = Company.CDEK;
        break;
      case Company.ENERGY:
        cloneTemplate.dataset.company = Company.ENERGY;
        break;
      case Company.OZON:
        cloneTemplate.dataset.company = Company.OZON;
        break;
      case Company.POSTAMAT:
        cloneTemplate.dataset.company = Company.POSTAMAT;
        break;
      default:
        throw new Error('Неизвестная компания');
    }

    cloneTemplate.dataset.id = id;

    return cloneTemplate;
  }

  filter(company) {
    let addresses = this.points.querySelectorAll('.points__item');
    addresses.forEach(function (item) {
      if (!item.classList.contains('points__item--empty')) {
        if (item.dataset.company === company || company === 'Все') {
          item.classList.remove('hide');
        } else {
          item.classList.add('hide');
        }
      }
    });
  }

  listClickHandler(evt) {
    this.callback.click(evt);
  }

  setListClickHandler(callback) {
    this.callback.click = callback;
    this.list.addEventListener('click', this.listClickHandler);
  }

  searchInputHandler(evt) {
    this.val = (evt.target.value).toLowerCase();
    let isFilled = value => value.length !== 0;
    let isVisibleAddress = address => !address.classList.contains('hide');
    let filtredAddresses = Array.from(this.addresses).filter((address) => isVisibleAddress(address)).length;
    let isEmptyList = count => count === filtredAddresses;

    this.addActiveClass(this.val, isFilled, isEmptyList);
  }

  addActiveClass(value, isFilled, isEmptyList) {

    if (isFilled(value)) {
      this.searchContainer.classList.add('active');
      this.list.classList.add('selected');
      let numOfInvisible = this.searchAddress(this.val);
      this.toggleEmptyText(numOfInvisible, isEmptyList);
    } else {
      this.resetAll();
    }
  }

  searchAddress(value) {
    let count = 0;
    Array.from(this.addresses)
      .filter(function (address) {
        return !(address.closest('.points__item').classList.contains('hide'));
      })
      .forEach(function (item) {
        let text = (item.textContent).toLowerCase();
        if (text.includes(value)) {
          item.closest('.points__item').classList.add('active');
        } else {
          item.closest('.points__item').classList.remove('active');
          count++;
        }
      });
    return count;
  }

  toggleEmptyText(count, isEmptyList) {
    let emptyItem = this.list.querySelector('.points__item--empty');
    if (isEmptyList(count)) {
      emptyItem.classList.add('active');
    } else {
      emptyItem.classList.remove('active');
    }
  }

  resetClickHandler() {
    this.search.value = '';
    this.resetAll();
  }

  resetAll() {
    let emptyItem = this.list.querySelector('.points__item--empty');

    this.searchContainer.classList.remove('active');
    this.list.classList.remove('selected');
    emptyItem.classList.remove('active');
  }

}
